import { useContext } from 'react';
import { Outlet, useNavigate, useLocation, Link } from 'react-router-dom';
import { AppShell } from '@rnd-payplus/alloy-react/patterns';
import { useAppDispatch } from '../../store';
import { logout } from '../../store/slices/authSlice';
import { TCHSidebar } from './TCHSidebar';
import { PageShellProvider, PageShellContext } from '../../contexts/PageShellContext';

function AppShellWithPageShell({
  sidebar,
  children,
}: {
  sidebar: React.ReactNode;
  children: React.ReactNode;
}) {
  const ctx = useContext(PageShellContext);

  return (
    <AppShell
      sidebar={sidebar}
      breadcrumbs={ctx?.breadcrumbs}
      alert={ctx?.alert}
      pageHeader={ctx?.pageHeader ?? undefined}
    >
      {children}
    </AppShell>
  );
}

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  const handleLogout = async () => {
    await dispatch(logout());
    navigate('/login');
  };

  const renderLink = (href: string, children: React.ReactNode) => (
    <Link to={href}>{children}</Link>
  );

  return (
    <PageShellProvider>
      <AppShellWithPageShell
        sidebar={
          <TCHSidebar
            user={{ name: 'User', email: 'user@tungsten.com' }}
            onLogout={handleLogout}
            currentPath={location.pathname}
            renderLink={renderLink}
          />
        }
      >
        <Outlet />
      </AppShellWithPageShell>
    </PageShellProvider>
  );
};

export default MainLayout;
